/**
 * @generated SignedSource<<ce003e5e447ac2c674093105278c3c88>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PeopleFieldPickerQuery$variables = {
  list: string;
  siteUrl: string;
};
export type PeopleFieldPickerQuery$data = {
  readonly getSharePointListFields: ReadonlyArray<{
    readonly displayName: string;
    readonly internalName: string;
    readonly peopleField: boolean;
  }> | null | undefined;
};
export type PeopleFieldPickerQuery = {
  response: PeopleFieldPickerQuery$data;
  variables: PeopleFieldPickerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "list"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "siteUrl"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "listId",
        "variableName": "list"
      },
      {
        "kind": "Variable",
        "name": "siteUrl",
        "variableName": "siteUrl"
      }
    ],
    "concreteType": "SharePointListField",
    "kind": "LinkedField",
    "name": "getSharePointListFields",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "internalName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "peopleField",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PeopleFieldPickerQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "PeopleFieldPickerQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "db09a56cebb7070a8bc4a52f60d9dbeb",
    "id": null,
    "metadata": {},
    "name": "PeopleFieldPickerQuery",
    "operationKind": "query",
    "text": "query PeopleFieldPickerQuery(\n  $siteUrl: String!\n  $list: String!\n) {\n  getSharePointListFields(siteUrl: $siteUrl, listId: $list) {\n    displayName\n    internalName\n    peopleField\n  }\n}\n"
  }
};
})();

(node as any).hash = "6f3ae4c458e72b0c38f0db8e2a6aff7c";

export default node;
